<template>
    <ListModule
        :label="$t('components.smart.featuredPositions.label')"
        :data="data()"
        :to="jobsURL()"
        :isLoading="loading()"
    />
</template>

<script>
import defaultLogo from '~/assets/img/DefaultLogo.png';
import dateToString from '~/utils/dateToString';

export default {
    data() {
        return {
            canGetPostings: false,
        };
    },
    computed: {
        featuredPostings() {
            return this.canGetPostings
                ? this.$interfaces.posting.get({
                      reactive: true,
                      mode: 'featured',
                  })
                : { loading: true };
        },
    },
    methods: {
        data() {
            return (this.featuredPostings.data || [])
                .slice(0, 5)
                .map(value => ({
                    ...value,
                    id: value.id,
                    header: value.title,
                    subheader: ''.concat(
                        value.country || '',
                        value.country && value.location ? ', ' : '',
                        value.location || ''
                    ),
                    subtitle: value.deadline
                        ? this.$t(
                              'shared.postingModule.postCard.deadline'
                          ).concat(': ', dateToString(value.deadline))
                        : '',
                    image: value.companyLogo || defaultLogo,
                }));
        },
        loading() {
            return this.featuredPostings.loading;
        },
        error() {
            return this.featuredPostings.error;
        },
        jobsURL: function() {
            return this.$URLS.jobDetail;
        },
    },
    mounted() {
        this.$interfaces.user.me.get().then(res => {
            this.canGetPostings = true;
        });
    },
};
</script>

<style scoped></style>
